<template>
  <div>
    <div class="printSettings">
        <div class="page-title">New York Department of Motor Vehicles</div>
        <div class="dmv-site">dmv.ny.gov</div>
        <div class="ticket-label">Your ticket number is:</div>
        <div class="ticket-field">{{ ticketNumber }}</div>
        <!-- <div class="name-label">Name:</div>&nbsp; -->
        <!-- div class="name-field">{{ booking.FirstName + " " + booking.LastName }}</div> -->
        <div v-if="bookingType === 'checkin'"
                class="name-label">
            Name: {{ firstName + " " + lastName }}
        </div>
        <div v-else-if="bookingType === 'walkin'"
                class="name-label">
            Phone: {{ formatedPhone }}
        </div>
        <div class="services-label">Service(s):</div>
        <!-- <div class="service-field" v-if="booking.TestTypeDescription">{{ booking.TestTypeDescription }}</div> -->
        <!-- <div class="service-field" v-if="booking.TestType2Description">{{ booking.TestType2Description }}</div> -->
        <!-- <div class="location">{{ booking.SiteName }}</div> -->
        <!-- <div class="dateAndTime">{{ formatedDateTime }}</div> -->
        <div class="service-field" v-if="serviceOne">{{ serviceOne }}</div>
        <div class="service-field" v-if="serviceTwo">{{ serviceTwo }}</div>
        <div class="location">{{ siteName }}</div>
        <div class="dateAndTime">{{ formattedCheckInDate }}</div>
        <!-- <br/> -->
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({ 
    
  }),
  props:{
    bookingType: String,
    ticketNumber: String, 
    firstName: String,
    lastName: String,
    siteName: String,
    formattedBookingDate: String,
    formattedCheckInDate: String,
    serviceOne: String,
    serviceTwo: String,
    formatedPhone: String,
  },
};

</script>
